import React, { useState, useEffect } from "react";
import { isEmpty } from 'lodash';
import { Link } from "@StarberryUtils"
import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import ModalTiny from "react-bootstrap/Modal"
import BookViewForm from "../forms/book-a-viewing-form"

const NEGOTIATOR = gql`
query GETNEG($URL: String!){
    offices(where:{CRM_ID: $URL}){
        Primary_Email
        Primary_Phone
        CRM_ID
        New_Homes_Email
        Sales_Email
        Lettings_Email
    }
}
`;

function BookViewing(props) {

    const [modalSharefrndformOpen, setSharefrndformOpen] = React.useState(false);
    const openSharefrndformModal = () => {
        setSharefrndformOpen(true);
    }
    const closeSharefrndformModal = () => {
        setSharefrndformOpen(false);
    }

    const { loading, error, data } = useQuery(NEGOTIATOR, {
        variables: { URL: props.id }
    });

    if (loading) return (
        <p>loading...</p>
    )

    let sales_email = ''
    let lettings_email = 'lettings@redbrik.co.uk'
    let new_homes_email = ''
    let primary_email = ''

    data.offices && data.offices.length > 0 && data.offices.map((neg, index) => {
        sales_email = neg.Sales_Email
        lettings_email = neg.Lettings_Email || 'lettings@redbrik.co.uk'
        new_homes_email = neg.New_Homes_Email
        primary_email = neg.Primary_Email
    })

    let to_email_id = primary_email || process.env.MAIL_TO;
    if (props.type === 'sales' && !isEmpty(sales_email))
        to_email_id = sales_email
    else if (props.type === 'lettings' && !isEmpty(primary_email))
        to_email_id = lettings_email
    else if (props.type === 'lettings')
        to_email_id = lettings_email

    // console.log("data => 221 ", props);
    return (
        <BookViewForm {...props} to_email_id={to_email_id} />
    )
}

export default BookViewing;
